import type {
  ChangeOldPasswordRequest,
  ChangePasswordRecoveryRequest,
  CheckRecoveryRequest,
  InitRecoveryRequest,
} from "./types";
import { rootApi } from "../../api";

const passwordApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    initRecovery: builder.mutation<void, InitRecoveryRequest>({
      query: (body) => ({
        url: "/password/recovery/init",
        method: "POST",
        body,
      }),
    }),
    checkRecovery: builder.mutation<void, CheckRecoveryRequest>({
      query: (body) => ({
        url: "/password/recovery/check",
        method: "POST",
        body,
      }),
    }),
    recoveryChangePassword: builder.mutation<void, ChangePasswordRecoveryRequest>({
      query: (body) => ({
        url: "/password/recovery/change",
        method: "POST",
        body,
      }),
    }),
    changeOldPasswordRequest: builder.mutation<void, ChangeOldPasswordRequest>({
      query: (body) => ({
        url: "/password/change",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useInitRecoveryMutation,
  useChangeOldPasswordRequestMutation,
  useCheckRecoveryMutation,
  useRecoveryChangePasswordMutation,
} = passwordApi;
